if (!customElements.get('rav-product-unified')) {
  customElements.define('rav-product-unified', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.form = this.querySelector('form[action*="/cart/add"]');
      this.strings = JSON.parse(this.querySelector('[data-rav-strings]').textContent);
      this.addEventListener('click', event => {
        const assurance = event.target.closest('[data-rav-assurance]');
        if (assurance) {
          const selected = assurance.getAttribute('aria-expanded') !== 'true' ? assurance.dataset.ravAssurance : null;
          this.querySelectorAll('[data-rav-assurance]').forEach(button => button.setAttribute('aria-expanded', String(button.dataset.ravAssurance === selected)));
          this.querySelectorAll('[data-rav-assurance-panel]').forEach(panel => { panel.hidden = panel.dataset.ravAssurancePanel !== selected; });
        }
        const anchor = event.target.closest('a[href^="#Rav"]');
        if (anchor) {
          const target = this.querySelector(anchor.getAttribute('href'));
          if (target) {
            event.preventDefault();
            event.stopPropagation();
            const header = document.getElementById('shopify-section-header');
            const announcement = document.getElementById('shopify-section-announcement-bar');
            const offset = (header?.offsetHeight || 0) + (announcement?.offsetHeight || 0) + 20;
            target.style.scrollMarginTop = offset + 'px';
            target.scrollIntoView({ behavior: 'instant', block: 'start' });
            history.replaceState(null, '', anchor.hash);
          }
        }
        const thumb = event.target.closest('[data-rav-show]');
        if (thumb) this.showMedia(thumb.dataset.ravShow);
        const quantityButton = event.target.closest('[data-rav-quantity]');
        if (quantityButton) {
          const input = this.form.querySelector('[name="quantity"]');
          if (quantityButton.dataset.ravQuantity === '1') input.stepUp(); else input.stepDown();
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, { signal });
      this.querySelector('[data-rav-variant]')?.addEventListener('change', event => {
        const url = new URL(location.href);
        url.searchParams.set('variant', event.target.value);
        location.assign(url);
      }, { signal });
      const currentUrl = new URL(location.href);
      this.querySelectorAll('[data-rav-related]').forEach(link => {
        const url = new URL(link.href);
        ['preview_theme_id', 'view'].forEach(key => {
          if (currentUrl.searchParams.has(key)) url.searchParams.set(key, currentUrl.searchParams.get(key));
        });
        link.href = url.href;
      });
      this.form?.addEventListener('submit', event => this.addToCart(event), { signal });
      const purchase = this.querySelector('.rav-pdp__purchase');
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.querySelector('[data-rav-sticky]').hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      }, { threshold: 0 });
      this.observer.observe(purchase);
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    showMedia(id) {
      this.querySelectorAll('[data-rav-media]').forEach(panel => {
        if (panel.dataset.ravMedia !== id && !panel.hidden) {
          panel.querySelectorAll('video').forEach(video => video.pause());
          panel.querySelectorAll('iframe').forEach(frame => {
            const src = frame.getAttribute('src');
            frame.setAttribute('src', src);
          });
        }
        panel.hidden = panel.dataset.ravMedia !== id;
      });
      this.querySelectorAll('[data-rav-show]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ravShow === id)));
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.busy || !this.form.reportValidity()) return;
      const submit = this.form.querySelector('[type="submit"]');
      if (submit.disabled) return;
      this.busy = true;
      const status = this.querySelector('[data-rav-status]');
      status.hidden = false;
      status.removeAttribute('data-error');
      status.textContent = this.strings.adding;
      submit.setAttribute('aria-busy', 'true');
      submit.disabled = true;
      const cart = document.querySelector('cart-notification');
      const data = new FormData(this.form);
      const root = window.Shopify?.routes?.root || '/';
      const canRenderCart = cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function';
      if (canRenderCart) {
        data.append('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        data.append('sections_url', location.pathname);
        cart.setActiveElement?.(submit);
      }
      try {
        const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.strings.error);
        status.textContent = this.strings.added + ' ';
        const cartLink = document.createElement('a');
        cartLink.href = root + 'cart';
        cartLink.textContent = this.strings.cart;
        status.append(cartLink);
        if (canRenderCart && result.sections) {
          try { cart.renderContents(result); } catch { cartLink.focus(); }
        }
        document.dispatchEvent(new CustomEvent('rav:cart-added', { detail: { product: result } }));
      } catch (error) {
        status.dataset.error = '';
        status.textContent = error.message || this.strings.error;
      } finally {
        this.busy = false;
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
      }
    }
  });
}
